import React from 'react';
import { Col } from 'react-bootstrap';
import Question from "./Question";
import { connect } from "react-redux";

class Questions extends React.Component {

	render() {
		let questions = this.props.questions[this.props.fid].filter(question => question.group === this.props.group).map(function (question, index) {
			return (<Question 
				question={question}
				key={question.id}
				qsi={this.props.qsi}
				qgi={this.props.qgi}
				qi={index+1}
				testObj={this.props.testObj}
			/>
			)
		}.bind(this));

		return (
			<div className="row questionnaire__sections__section__groups__group">
				<Col lg={12}>
					{questions}
				</Col>
			</div>
		)
	}
}

export default connect(state => ({ questions: state.formQuestions}))(Questions);


// WEBPACK FOOTER //
// ./src/modules/form/view.1/Questions.js